import {CssKey} from '../mutations/style/css-style';

export function styleEquals(
  node: HTMLElement,
  key: CssKey,
  value: string | null | undefined,
) {
  // Use the node's own document window since nodes may live in the editor iframe
  const nodeWindow = node.ownerDocument.defaultView ?? window;
  return nodeWindow.getComputedStyle(node)[key] === value;
}
